import { render } from "./Heading3.vue?vue&type=template&id=681cbc6b&scoped=true&ts=true"
import script from "./Heading3.vue?vue&type=script&lang=ts"
export * from "./Heading3.vue?vue&type=script&lang=ts"

import "./Heading3.vue?vue&type=style&index=0&id=681cbc6b&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\artur\\Documents\\CODELEX\\2 - CODELEX\\JOB SEARCH\\COMPANY ASSIGNMENTS\\Printful\\frontend-quiz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-681cbc6b"]])

export default __exports__